import React from 'react';
// @ts-ignore
import { Button, FormGroup, HorizontalRule, Link, Loader } from 'arag-ui-lib';
import FormikFieldWrapper from '../general/formikFieldWrapper/formikFieldWrapper';
import config from '../../utils/constants/config';
import GENERAL_FUNCTIONS from '../../utils/functions/functions';
import { IsUploadingFile } from '../../utils/constants/interfaces';
import codes from '../../utils/constants/codes';
import ProgressBar from '../general/progressBar/progressBar';
import { useTranslation } from 'react-i18next';

// If we keep this solution we need to remove claimCommunicatorFiles.js and ClaimCommunicatorFilesContainer.js and comments from  GENERAL_FUNCTIONS.validateCommunicatorComments
type File = {
    hasMetaData: boolean;
    abortController: any;
    file: {
        name: string;
        encodedFile: string;
    } | null;
    id: string;
    name: string;
};
type Props = {
    index: number;
    file: {
        file: File | null;
        id: string;
        abortController: any;
        fileToMB: number;
    };
    arrayHelpers: any;
    error: any;
    setFieldValue: Function;
    files: Array<File>;
    setUploadingfile: Function;
    isUploadingFile: IsUploadingFile | any;
    postCommunicatorMessageLoading: boolean;
    claimApplication: any;
    progress: any;
    setProgress: Function;
};

function ClaimCommunicatorFilesArray(props: Props): JSX.Element {
    const {
        index,
        file,
        arrayHelpers,
        error,
        setFieldValue,
        files,
        setUploadingfile,
        isUploadingFile,
        postCommunicatorMessageLoading,
        claimApplication,
        progress,
        setProgress,
    } = props;

    const { t } = useTranslation();
    const handleFileDrop = async (file: any, fileId: string, file1: any) => {
        // Create a new AbortController instance
        const abortController = new AbortController();
        let result = files?.find((item: File) => {
            if (item?.id === fileId) {
                return item;
            }
            return false;
        });

        //check if file already exists
        //and if exists remove it
        //and replace it with the new
        if (result?.file) {
            await GENERAL_FUNCTIONS.requestToRemoveFile(result.id);
        }
        setFieldValue(`files.${index}`, {
            file: file,
        });

        const fileSize = file1?.size;
        const fileToMB = Math.round(fileSize / 1024);
        const attachmentId = await GENERAL_FUNCTIONS.requestToUploadFileToBlob({
            fileName: file1?.name,
            claimApplicationId: claimApplication.id,
            type: codes.attachmentTypeEnum.CommunicationDirectAttachment,
        });
        setUploadingfile({
            fileId: attachmentId?.attachmentId,
            type: codes.uploading,
        });

        if (attachmentId) {
            setFieldValue(`files.${index}`, {
                id: attachmentId.attachmentId,
                file: file,
                blobURI: attachmentId.blobURI,
                abortController: abortController,
                fileToMB: fileToMB,
                hasMetaData: false,
            });
        }
        // Add the abortController instance to the file object

        await GENERAL_FUNCTIONS.fileUploadAzureBlob(
            attachmentId,
            file1,
            (progress: number, id: any, hasMetaData: boolean) => {
                setProgress((prevProgress: any) => {
                    // Find the index of the progress object with the matching fileId
                    const index = prevProgress.findIndex(
                        (item: { id: string }) => item.id === id,
                    );
                    // Create a new progress object with the updated progress value
                    const updatedProgress = { id: id, progress: progress };
                    // Update the progress array by replacing the old object with the updated one,
                    // or appending the updated object if it doesn't exist yet
                    if (index !== -1) {
                        return [
                            ...prevProgress.slice(0, index),
                            updatedProgress,
                            ...prevProgress.slice(index + 1),
                        ];
                    } else {
                        return [...prevProgress, updatedProgress];
                    }
                });
            },
            abortController,
            files[index].hasMetaData,
        );
        setUploadingfile(null);
    };

    const handleRemoveAttachment = async () => {
        if (files[index].file) {
            setUploadingfile({ fileId: files[index].id, type: codes.removing });
            await GENERAL_FUNCTIONS.requestToRemoveFile(files[index].id);
            setUploadingfile(null);
        }
        if (files.length === 1) {
            setFieldValue(`files.${index}`, {
                file: null,
                id: null,
            });
        } else {
            arrayHelpers.remove(index);
        }
    };
    const cancelUpload = async (fileId: string) => {
        // Find the file with the corresponding fileId
        const file = files.find((item: File) => item.id === fileId);
        // Remove the file from the progress array
        await GENERAL_FUNCTIONS.requestToRemoveFile(fileId);
        setProgress((prevProgress: any) => [
            ...prevProgress.filter(
                (item: { id: string }) => item.id !== fileId,
            ),
        ]);
        if (file && file.abortController) {
            // Cancel the file upload by aborting the controller signal
            file.abortController.abort();

            // Remove the file from the form values
            if (files.length === 1) {
                setFieldValue(`files.${index}`, {
                    file: null,
                    id: null,
                });
            } else {
                arrayHelpers.remove(index);
            }
        }
    };

    return (
        <div key={file?.id}>
            <div>
                <HorizontalRule variant="pale" />
            </div>
            <div className="row" style={{ marginTop: '20px' }}>
                <div className="col-sm-12" style={{ marginTop: '10px' }}>
                    <FormikFieldWrapper
                        labelSize={'col-sm-3'}
                        inputSize={'col-sm-7'}
                        label={t('uploadFile')}
                        variant={'file'}
                        customErrorMessage={
                            error && error.files
                                ? error.files[index]?.file
                                : null
                        }
                        getInputProps={(formikBag: {
                            setFieldError: (
                                fileName: string,
                                fileType: string | null,
                            ) => void;
                        }) => ({
                            name: `files.${index}.file`,
                            label: file?.file ? file.file.name : t('browse'),
                            buttonLabel: t('chooseFile'),
                            disabled: postCommunicatorMessageLoading,
                            accepts: config.ACCEPTED_FILE_EXTENSIONS,
                            allowMultiple: false,
                            onDrop: async (
                                files: any,
                                rejectedFile: string | any[],
                                event: any,
                            ) => {
                                if (rejectedFile && rejectedFile.length === 1) {
                                    formikBag.setFieldError(
                                        `files.${index}.file`,
                                        ` File type ${GENERAL_FUNCTIONS.validateFileExtensions(rejectedFile[0].name)} is not supported`,
                                    );
                                } else if (
                                    rejectedFile &&
                                    rejectedFile.length > 1
                                ) {
                                    formikBag.setFieldError(
                                        `files.${index}.file`,
                                        "Please click 'Add another' to add multiple files",
                                    );
                                } else {
                                    formikBag.setFieldError(
                                        `files.${index}.file`,
                                        null,
                                    );
                                }

                                const onDropEvent = event?.target?.files
                                    ? event.target.files[0]
                                    : files[0];
                                const readFiles = files?.map((file: any) => {
                                    const sizeOfNull =
                                        GENERAL_FUNCTIONS.sizeOfFiles(file, {
                                            option: 1,
                                            setFieldError: null,
                                            formikBag: formikBag,
                                            field: 'file',
                                            rejectedFile: rejectedFile,
                                        });

                                    return {
                                        name: sizeOfNull
                                            ? 'Browse'
                                            : file?.name,
                                        error: sizeOfNull,
                                        size: file?.size,
                                    } as any;
                                });
                                if (readFiles[0]?.size > 1024 * 1024 * 100) {
                                    formikBag.setFieldError(
                                        `files.${index}.file`,
                                        'File should be less than 100MB',
                                    );
                                }

                                if (
                                    readFiles?.length === 1 &&
                                    !readFiles[0]?.error
                                ) {
                                    await handleFileDrop(
                                        readFiles[0],
                                        file.id,
                                        onDropEvent,
                                    );
                                }
                            },
                        })}
                        inputProps={{
                            name: `files.${index}.file`,
                        }}
                    />
                </div>
                {isUploadingFile?.fileId === files[index]?.id &&
                    !progress?.find((i: any) => i.id === file?.id)?.id && (
                        <div className="col-sm-12">
                            <ProgressBar
                                progress={{
                                    id: isUploadingFile?.fileId,
                                    progress: 0,
                                }}
                                mainStyles={'col-sm-7'}
                                additionalStyles={'col-sm-3'}
                            />
                        </div>
                    )}
                {progress?.find((i: any) => i.id === file.id)?.id && (
                    <div className="col-sm-12">
                        <ProgressBar
                            progress={progress?.find(
                                (i: any) => i.id === file.id,
                            )}
                            mainStyles={'col-sm-7'}
                            additionalStyles={'col-sm-3'}
                        />
                    </div>
                )}
            </div>
            <FormGroup
                labelSize="col-sm-3"
                inputSize="col-sm-9"
                label=""
                variant="plain"
                inputProps={{
                    label: (
                        <div>
                            <Link
                                variant="tertiary"
                                arrowDirection="left"
                                label={t('addAnother')}
                                onClick={() =>
                                    arrayHelpers.insert(files.length, {
                                        id: file.id + 1,
                                        file: null,
                                    })
                                }
                            />
                            <Link
                                variant="tertiary"
                                arrowDirection="left"
                                label={t('remove')}
                                disabled={
                                    isUploadingFile?.fileId ===
                                        files[index].id ||
                                    progress?.find((i: any) => i.id === file.id)
                                        ?.progress < codes.progressEnd
                                }
                                onClick={handleRemoveAttachment}
                            />
                            {file.abortController &&
                                file.fileToMB > codes.thresholdMb &&
                                progress?.find((i: any) => i.id === file.id)
                                    ?.progress < codes.progressEnd && (
                                    <Link
                                        variant="tertiary"
                                        label={t('undo')}
                                        id={'cancelUpload'}
                                        onClick={() => cancelUpload(file?.id)}
                                    />
                                )}
                        </div>
                    ),
                }}
            />
        </div>
    );
}

export default ClaimCommunicatorFilesArray;
